const {
  getContentValues,
  setValue,
  getContentValue
} = require('@truqc/content-path');
const {
  mergeDeepRight
} = require('ramda');
const clone = json => JSON.parse(JSON.stringify(json));
const matchesCriteria = (format, criteria) => {
  let result = true;
  Object.keys(criteria).forEach(prop => {
    // handle tags arrays
    if (prop === 'tags') {
      result = (criteria[prop] || []).some(crit => (format[prop] || []).some(form => crit === form));
    } else if (criteria[prop] !== format[prop]) {
      // inequality
      // ignore property being "defined" criteria
      if (!(criteria[prop] === 'isDefined' && format[prop] !== undefined)) {
        result = false;
      }
    }
  });
  return result;
};

/**
 *  Gather paths to the components from the formatInput
 */
const keyPathsToCriteria = (criteriaIn, formatInputIn, currentPath = '') => {
  const criteria = Array.isArray(criteriaIn) ? criteriaIn : [criteriaIn];
  let formatInput = formatInputIn || {};
  if (typeof formatInput === 'string') {
    formatInput = JSON.parse(formatInputIn);
  }
  let keyPaths = [];
  if (criteria.some(criterium => matchesCriteria(formatInput, criterium))) {
    keyPaths.push({
      path: currentPath,
      component: formatInput
    });
  }
  if (Array.isArray(formatInput.children) && formatInput.children.length > 0) {
    formatInput.children.forEach(child => {
      let tmppath = currentPath;
      if (child.contentPath) {
        if (child.contentPath[0] === '/') {
          // start at top of tree
          tmppath = child.contentPath;
        } else {
          tmppath = `${currentPath}/${child.contentPath}`;
        }
      }

      // add a wildcard path whenever a collection is found
      if (child.type === 'collection') {
        tmppath += '/*';
      }
      keyPaths = keyPaths.concat(keyPathsToCriteria(criteria, child, tmppath));
    });
  }
  return keyPaths;
};

/**
 * @function valuesFromPaths - get values from the given components
 * @param {*} keyPaths
 * @param {*} formatInput
 * @param {*} content
 */
const valuesFromPaths = (keyPaths, content) => {
  const result = [];
  keyPaths.forEach(({
    path
  }) => {
    const contentAtPath = getContentValues(path, content);
    if (contentAtPath !== undefined) {
      // null is valid content
      result.push(...contentAtPath); // mutating result
    }
  });
  return result;
};

/**
 * @function valuesFromComponent - get values from the given components
 * @param {*} componentName
 * @param {*} formatInput
 * @param {*} content
 * @param {*} matchingCriteria
 */
const valuesFromComponent = (componentName, formatInput, content, matchingCriteria = null) => {
  let criteria = {
    type: componentName
  };
  if (matchingCriteria !== null) {
    criteria = mergeDeepRight(matchesCriteria, criteria);
  }
  const keyPaths = keyPathsToCriteria(criteria, formatInput);
  return valuesFromPaths(keyPaths, content);
};
const nullPatchFromCriteria = (resultIn, patch, formatInput, criteria) => {
  let result = clone(resultIn);
  const paths = keyPathsToCriteria(criteria, formatInput) || [];
  if (paths.length > 0) {
    // these are all single picker values.
    // we need to add the _atomic: true to the
    // merge patch
    paths.forEach(pathObject => {
      const {
        path
      } = pathObject;
      // IFF there is content in the patch, then set the
      // premerge patch to null.
      const contentAtPath = getContentValue(path, patch);
      if (contentAtPath !== undefined) {
        // check keys and remove `null` since
        // we are rewriting the whole tree.
        // null is valid content
        // mutate `result` !!!
        result = setValue(path, result, null);
      }
    });
  }
  return result;
};

/**
 * @function searchContentForKeys Performs a recursive search for a key, returning the values
 * @param {Object} content The content to search for the key in
 * @param {String} key The key to search for
 */
const searchContentForKeys = (content, key) => {
  let result = [];
  if (!content) {
    return result;
  }
  const contentKeys = Object.keys(content);
  const matchFound = contentKeys.some(contentKey => contentKey === key);
  if (matchFound) {
    result.push(content[key]);
  }
  contentKeys.forEach(contentKey => {
    const root = content[contentKey];
    if (typeof root === 'object' && root !== null && Object.keys(root).length > 0) {
      result = result.concat(searchContentForKeys(root, key));
    }
  });
  return result;
};

/**
 * Helper to parse contentPaths into MySQL JSON format
 * e.g. Converts /path/to/content to $.path.to.content
 * @param {String} contentPath - The content path to convert
 */
const contentPathToJsonPath = contentPath => {
  if (typeof contentPath !== 'string' || !contentPath.match(/^\/[^/]*(\/[^/]+)*$/)) {
    throw new Error(`Invalid contentPath sent to server (absolute?) ${contentPath}`);
  }
  if (contentPath === '/') {
    return '$';
  }
  const jsonPath = contentPath.split('/').map(p => {
    if (p.indexOf('-') !== -1) {
      // quote keys with dashes (e.g., UUIDs)
      return `"${p}"`;
    }
    return p;
  }).join('.');
  return `$${jsonPath}`;
};
module.exports = {
  matchesCriteria,
  contentPathToJsonPath,
  keyPathsToCriteria,
  searchContentForKeys,
  nullPatchFromCriteria,
  valuesFromComponent,
  valuesFromPaths
};